import axios from "@/http";
import { handleGetRequestParams } from '@/common/js/util'

class LogisticsBill {
  /* 账单列表 */
  static getLogisticsBillList(option) {
    let url = `/oa/api/logistic/company/payment/bill/page?`;
    url += handleGetRequestParams(option)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 账单核实 */
  static postVerify(data) {
    const url = `/oa/api/logistic/company/payment/bill/check`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 导出账单 */
  static getExport(data) {
    let url = `/oa/api/download/logistic/payment/bill?`
    url += handleGetRequestParams(data)
    return axios.get(url, { responseType: "blob" }).then(res => {
      return Promise.resolve(res);
    });
  }
}

export default LogisticsBill;